export default __webpack_public_path__ + "static/StefanZurflueh-b9b153e48f79e974d9b82950355c0c5a.jpg";